<template>
  <div class="ranking-w c_fff" @scroll="onScrollRanking" ref="ranking">
    <div class="head" ref="head" :style="{'top':rankingScrollTop+'px'}">
      <div class="title d_flex align_item_c">
        <!-- <img class="img_1" src="../assets/images/bigdata_1.png" alt=""> -->
        <span class="span_1 fz20">交易排名</span>
      </div>
      <div class="sort-filed c-row">
        <span style="width: 58px">排名</span>
        <span style="width: 58px">区域</span>
        <span style="width: 148px">挂牌面积（亩）</span>
        <span style="width: 112px">交易总宗数</span>
      </div>
    </div>

      <div class="content-w" :style="{ 'padding-top': headHeight - 0 + 'px' }">
        <div
          class="c-row c-item"
          v-for="(item, index) in rankData"
          :key="item.code"
        >
          <span
            :style="{
              width: '58px',
              background: 'url(' + item.icon + ') center center no-repeat',
            }"
            :title="index + 1"
            >{{ index + 1 }}</span
          >
          <span
            style="
              width: 58px;
            "
            class="text_ellipsis fz14"
            :title="item.locName"
            >{{ item.locName }}</span
          >
          <span style="width: 148px" :title="item.listingArea">{{
            item.listingArea
          }}</span>
          <span style="width: 112px" :title="item.vol">{{
            item.vol
          }}</span>
        </div>
      </div>

  </div>
</template>

<script>
import {data_ranking,} from '@/api/portal'
import { mapGetters } from 'vuex'

export default {

  data() {
    return {
      rankingScrollTop: 0,
      headHeight: 0,

      rankData:[],//排名数据

    };
  },
   computed: {
    ...mapGetters(['siteInfo']),
  },
  watch: {
    rankData: function (n, o) {
      //给前3名设置图标
      if (n && n.length) {
        for (let i in n) {
          if (i <= 2) {
            n[i].icon = require(`../assets/images/ranking_${i - 0 + 1}.png`);
          }
        }
      }
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.getRankingData()
        }
      },
      immediate:true,
      deep:true
    }
  },

  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.headHeight = this.$refs.head.offsetHeight;
    });
  },
  methods: {


    async getRankingData(){
      let {data} =  await data_ranking()  //获取排名数据 api
      this.rankData = data
    },

    onScrollRanking(e) {
      this.rankingScrollTop = this.$refs.ranking.scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking-w {
  overflow: auto;
  position: relative;
  width: 374px;
  height: 100%;
  background-color: rgba(52,50,101,.5);
  & {
    scrollbar-width: none; //火狐
  }
  &::-webkit-scrollbar {
    display: none;  //谷歌
  }

  &::-webkit-scrollbar-thumb {
  }
    & > .head {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 2;
      background: url("../assets/images/ranking_4.png") 0 100%/cover no-repeat;

      .title {
        padding:9px 0 9px 16px;
        font-weight: bold;
        font-size: 22px;
        letter-spacing: 2px;
        // margin: 9px 0 0 0;
        // background: url("../assets/images/bigdata_5.png") 0 100%/contain no-repeat;
      }
      .sort-filed {
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
        background-color: rgba($color: #343265, $alpha: .5);
        & > span {
          text-align: center;
        }
      }
    }

    .content-w {
      position: sticky;
      z-index: 1;
    }
    .c-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

    }
    .c-item {
      color: #fff;
      &:nth-child(odd){
        background-color: #3B3A66;
      }
      &:nth-child(even){
        background-color: rgba($color: #3B3A66, $alpha: .5);
      }
      & > span {
        text-align: center;
        line-height: 23px;
      }
    }



  .img_1{
    width: 18px;
    height: 18px;
    margin: 0 7px 0 0;
  }
  .span_1{
    margin: 0 0 0 25px;
  }
}
</style>